
	import Modal from '@/components/Modal.vue';
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import { Property } from '@/store/prescription/prescriptionDefinition';

	@Observer
	@Component({
		components: {
			Modal
		}
	})
	export default class HelpModal extends Vue {
		@Prop({ required: true }) prop!: Property;

		close() {
			this.$emit('close');
			this.$state.prescription.allowUpdate = true;
		}
		save() {
			this.$emit('close', true);
			this.$state.prescription.allowUpdate = true;
		}

		mounted() {
			this.$state.prescription.allowUpdate = false;
		}

		private getImagePath(displayName: string) {
			displayName = displayName === 'Met Pads (1/8")' ? 'Met Pads' : displayName;
			return '/assets/images/prescriptions/' + displayName + '.svg';
		}
	}
